import { useFetcher } from '@remix-run/react'
import { HoneypotInputs } from 'remix-utils/honeypot/react'

export type MailListResult = { ok: true } | { ok: false; error: string }

export function MailForm() {
	const fetcher = useFetcher<MailListResult>()
	const done = fetcher.data && 'ok' in fetcher.data && fetcher.data.ok

	if (done) {
		return (
			<p className="max-w-[40ch] text-base leading-relaxed text-cream">
				You are on the list. We will write when the next session is set.
			</p>
		)
	}

	const error =
		fetcher.data && 'error' in fetcher.data ? fetcher.data.error : null

	return (
		<fetcher.Form method="POST" className="flex w-full max-w-md flex-col gap-3">
			<HoneypotInputs />
			<label
				htmlFor="list-email"
				className="font-mono text-xs uppercase tracking-[0.16em] text-cream/70"
			>
				Email
			</label>
			<input
				id="list-email"
				name="email"
				type="email"
				autoComplete="email"
				required
				className="border border-cream/40 bg-transparent px-3 py-3 text-base text-cream outline-none placeholder:text-cream/40 focus:border-terracotta"
				placeholder="you@example.com"
			/>
			{error ? <p className="text-sm text-terracotta">{error}</p> : null}
			<button
				type="submit"
				disabled={fetcher.state !== 'idle'}
				className="self-start border border-cream bg-cream px-5 py-3 text-sm font-medium tracking-wide text-navy transition-transform duration-150 hover:bg-terracotta hover:text-cream active:scale-[0.98] disabled:opacity-60"
			>
				{fetcher.state === 'idle' ? 'Join the list' : 'Saving…'}
			</button>
		</fetcher.Form>
	)
}
